import { z, type ZodError } from "zod";

export const appEnvironmentSchema = z.enum(["local", "test", "preview", "production"]);
export type AppEnvironment = z.infer<typeof appEnvironmentSchema>;

export type ConfigurationIssue = Readonly<{
  path: string;
  code: string;
  message: string;
}>;

export class ConfigurationError extends Error {
  readonly issues: readonly ConfigurationIssue[];

  constructor(scope: "client" | "server", error: ZodError) {
    super(`Invalid ${scope} configuration`);
    this.name = "ConfigurationError";
    this.issues = Object.freeze(
      error.issues.map((issue) =>
        Object.freeze({
          path: issue.path.join(".") || "(root)",
          code: issue.code,
          message: issue.message,
        }),
      ),
    );
  }
}

export function selectEnvironment(
  input: Record<string, unknown>,
  allowedKeys: readonly string[],
): Record<string, unknown> {
  return Object.fromEntries(allowedKeys.map((key) => [key, input[key]]));
}

